import { Component, Input, ViewChildren, QueryList, OnChanges, SimpleChanges } from '@angular/core';

import { ApiError, MessageService, notCloseMessageOptions } from '../../../../../core';
import { ClienteUnidadeNegocioSearchMercado } from './cliente-unidade-negocio-search-mercado';
import { UnidadeNegocioMercado, UnidadeNegocioMercadoFilter, UnidadeNegocioMercadoHttpService } from '../../../../unidade-negocio/mercado';
import { ClientUnidadeNegocioNaturezaVendaComponent } from '../natureza-venda';
import { mercadoAtivo, mercadoInativo } from '../../../../mercado';
import { ItemTipo } from '../../../../item-tipo';

@Component({
    selector: 'sgt-cliente-unidade-negocio-mercado',
    templateUrl: './cliente-unidade-negocio-mercado.component.html',
    styleUrls: ['./cliente-unidade-negocio-mercado.component.less']
})
export class ClienteUnidadeNegocioMercadoComponent implements OnChanges {
    @Input() canEdit = true;
    /** ID do cliente */
    @Input() idCliente: number;

    /** ID da unidade de negócio */
    @Input() idUnidadeNegocio: number;
    /** Nome da unidade de negócio */
    @Input() nomeUnidadeNegocio: string;
    /** Index da unidade de negócio */
    @Input() indexUnidadeNegocio: number;

    /** Mercados vinculados na unidade de negócio */
    mercados: UnidadeNegocioMercado[];
    mercadoSituacaoAtivo = mercadoAtivo.id;
    mercadoSituacaoInativo = mercadoInativo.id;

    @Input() itensTipos: ItemTipo[] = [];

    @Input() entities: ClienteUnidadeNegocioSearchMercado[] = [];
    /** Forms das naturezas de vendas */
    @ViewChildren('naturezaVendaForm') naturezasVendasForms: QueryList<ClientUnidadeNegocioNaturezaVendaComponent>;

    constructor(private messageService: MessageService,
                private unidadeNegocioMercadoHttpService: UnidadeNegocioMercadoHttpService) { }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idUnidadeNegocio') {
                // Se possuir o ID da Unidade de Negócio selecionado então pesquisamos os mercados vinculados a esta Unidade de Negócio
                if (this.idUnidadeNegocio) {
                    this.searchMercados(this.idUnidadeNegocio);
                } else {
                    this.mercados = [];
                }
            }
        }
    }

    /** Pesquisas os mercados vinculados na unidade de negócio */
    private searchMercados(idUnidadeNegocio: number) {
        const filter = new UnidadeNegocioMercadoFilter()
        this.unidadeNegocioMercadoHttpService.search(idUnidadeNegocio, filter)
            .subscribe(
                mercados => this.mercados = mercados,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os mercados', error)
            );
    }

    insert() {
        if (!this.canEdit) {
            return;
        }

        const entity = new ClienteUnidadeNegocioSearchMercado();
        this.entities.push(entity);
    }

    delete(index: number) {
        if (index < 0 || !this.canEdit) {
            return;
        }

        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente remover o mercado ${entity?.nomeMercado ?? ''} da unidade de negócio ${this.nomeUnidadeNegocio ?? ''}?`, 'Confirme').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Ao selecionar o mercado */
    onSelectMercado(entity: ClienteUnidadeNegocioSearchMercado, idMercado: number) {
        if (idMercado) {
            entity.idMercado = idMercado;

            const unidadeNegocioMercado = this.mercados?.find(mercadoFilter => mercadoFilter.id === idMercado);
            entity.nomeMercado = unidadeNegocioMercado?.mercado?.nome ?? null;
        } else {
            entity.idMercado = null;
            entity.nomeMercado = null;
        }
    }

    /** Verifica os mercados estão válidos */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Verificando se as naturezas de vendas estão válidas
        let isClientesNaturezasVendasValid = true
        this.naturezasVendasForms?.forEach(naturezaVendaForm => {
            if (!naturezaVendaForm.isValid()) {
                isClientesNaturezasVendasValid = false;
            }
        });
        if (!isClientesNaturezasVendasValid) {
            return false;
        }

        // Verificando se os mercados estão válidos
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];

            // Mercado não informado mas com naturezas de vendas adicionadas
            if (!entity.idMercado && entity.naturezasVendas?.length > 0) {
                this.messageService.warning('É obrigatório selecionar o mercado quando este possuir alguma natureza de venda. Selecione o mercado ou remova as naturezas de vendas', 'Não é possível adicionar naturezas de vendas para um mercado não selecionado', notCloseMessageOptions);
                return false;
            }

            const count = this.entities.filter(entityFilter => entityFilter.idMercado && entityFilter.idMercado === entity.idMercado).length;
            if (count > 1) {
                this.messageService.warning(`O mercado ${entity.nomeMercado ?? ''} já está adicionado na unidade de negócio ${this.nomeUnidadeNegocio ?? ''}. Remova ou altere o mercado duplicado`, 'Não é possível adicionar dois mercados iguais na mesma unidade de negócio', notCloseMessageOptions);
                return false;
            }
        }
        return true;
    }
}
